<template>
  <div class="mt-4 pb-4">
    <template v-if="path.indexOf('editPlan') !== -1 || path.indexOf('newPlan') !== -1">
      <a @click="addPlace" class="button-primary block button-icon icon-left">
        <svg height="12" viewBox="0 0 12 12" width="12" xmlns="http://www.w3.org/2000/svg" class="text-white"><path d="m734.333333 280.666667v2.666666h-2.666666c-.36819 0-.666667.298477-.666667.666667s.298477.666667.666667.666667h2.666666v2.666666c0 .36819.298477.666667.666667.666667s.666667-.298477.666667-.666667v-2.666666h2.666666c.36819 0 .666667-.298477.666667-.666667s-.298477-.666667-.666667-.666667h-2.666666v-2.666666c0-.36819-.298477-.666667-.666667-.666667s-.666667.298477-.666667.666667" transform="translate(-729 -278)"/></svg>
        <span>{{ $t('tour_add_to_plan') }}</span>
      </a>
    </template>
    <template v-else-if="getShowButton">
      <route-place :place="place" />
      <div v-if="token">
        <a @click="createPlan" class="button-primary block mt-2">
          {{ $t('tour_create_plan') }}
        </a>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import RoutePlace from './RoutePlace'
import Constants from '../../../constants'

export default {
  components: {
    RoutePlace
  },
  props: {
    place: {
      type: Object,
      required: true
    },
    addPlace: {
      type: Function,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      path: null
    }
  },
  created () {
    this.path = this.$route.path
  },
  methods: {
    closeMap: function () {
      this.$emit('closeMap')
    },
    createPlan: function () {
      // GoogleAnalytics
      this.$gtag.event("POIからプラン作成", {
        poi_name: this.place.name
      });
      const areaId = this.$store.getters['user/getAreaId']
      if (areaId == Constants.DEFAULT_AREA_ID) {
        this.$router.push({ name: 'newPlan', query: { lang: this.$store.getters['user/getLang'], poiId: this.place.id } })
      }else{
        this.$router.push({ name: 'newPlan', query: { lang: this.$store.getters['user/getLang'], poiId: this.place.id }, params:{ areaId: areaId } })
      }
    }
  },
  computed: {
    ...mapGetters({
      token: 'user/getToken',
      getShowButton: 'drawer/getIsShowButton'
    })
  }
}
</script>
